import always from "./always";
import stubUndefined from "./stubUndefined";

const noop = always(stubUndefined());

export default noop;
